var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogotextVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.93 132.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbec0;}.cls-2{fill:#f0f1f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo text_vertical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.9,480.8l-2.29-5.54H223l-2.38,5.54h-4.38l8.93-21.44h3.13l9,21.44H232.9ZM226.73,465l-2.29,6.5H229Z",
    transform: "translate(-216.22 -349.24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.2,468.24V480.8h-3.86V468.24h-1.89v-3.51h1.89v-5.37h3.86v5.37h2.32v3.51H243.2Z",
    transform: "translate(-216.22 -349.24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.87,480.8L263.6,461.2v19.6h-5v-27h5.69l11.17,19.64V453.83h5v27h-5.58Z",
    transform: "translate(-216.22 -349.24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.42,481.28a14.09,14.09,0,0,1-14.2-14.05,13.91,13.91,0,0,1,13.87-13.87,13.73,13.73,0,0,1,12.78,8.21h-5.58a8.1,8.1,0,0,0-7.08-3.39,8.85,8.85,0,0,0-8.94,9.09,9.18,9.18,0,0,0,9.05,9.2c2.59,0,4.49-.88,6.68-3.17h5.88A13.32,13.32,0,0,1,298.42,481.28Z",
    transform: "translate(-216.22 -349.24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.09,479.31c-2.19,1.09-4.64,1.5-8.72,1.5h-6.28v-27h6.17c4.23,0,7.45.66,9.56,1.93,3.76,2.26,5.88,6.5,5.88,11.61C335.69,472.81,333.25,477.26,329.09,479.31Zm-2.56-19.6c-1.57-.8-3.28-1.09-6.46-1.09h-1V476h1.09c3,0,5.07-.37,6.57-1.21a8.32,8.32,0,0,0,3.91-7.45C330.66,463.9,329.09,461,326.53,459.71Z",
    transform: "translate(-216.22 -349.24)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.83,480.8h-7.19v-27h5.55c4,0,5.69.29,7.3,1.31a6.78,6.78,0,0,1,3.07,5.88,5,5,0,0,1-3,5.07c3.43,1.42,4.6,3.47,4.6,6.68C357.16,477.7,353.76,480.8,346.83,480.8Zm-0.15-22.08h-2v5.51h1.61c3,0,4.31-.84,4.31-2.77S349.27,458.72,346.68,458.72Zm0.33,10.4h-2.37V476h2.48c3.5,0,5-1,5-3.36S350.48,469.12,347,469.12Z",
    transform: "translate(-216.22 -349.24)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.07,383.41A26.13,26.13,0,1,0,296,357.55a5,5,0,1,0-7.53,0,26.17,26.17,0,0,0-22.36,25.86h0Zm23.12-29.15a3,3,0,1,1,3,3,3,3,0,0,1-3-3h0Zm3,5a24.12,24.12,0,1,1-24.12,24.12,24.12,24.12,0,0,1,24.12-24.12h0Zm0,0",
    transform: "translate(-216.22 -349.24)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.2,404.51a21.11,21.11,0,1,0-21.11-21.11,21.11,21.11,0,0,0,21.11,21.11h0Zm0-40.2a19.1,19.1,0,1,1-19.1,19.1,19.1,19.1,0,0,1,19.1-19.1h0Zm0,0",
    transform: "translate(-216.22 -349.24)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.73,384.41L280.28,394a1,1,0,0,0,1.37,1.37l9.55-5.46v9.61a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V388.73l1.84-1.05,7.81,7.81a1,1,0,0,0,1.42,0h0a1,1,0,0,0,0-1.42l-7.81-7.81,1.05-1.84h9.75a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1h-8.61l5.46-9.55a1,1,0,0,0-1.37-1.37l-9.55,5.46v-9.61a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v10.76l-1.84,1.05-7.81-7.81a1,1,0,0,0-1.42,0h0a1,1,0,0,0,0,1.42l7.81,7.81-1.05,1.84h-9.75a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h8.61Zm14.82-9.36-6.08,10.63-10.63,6.08,6.08-10.63Zm0,0",
    transform: "translate(-216.22 -349.24)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.75,
    y: 32.94,
    width: 2.46,
    height: 2.46,
    rx: 1.23,
    ry: 1.23
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotextVertical);
export default __webpack_public_path__ + "static/media/Logo text_vertical.cb415e19.svg";
export { ForwardRef as ReactComponent };